import type { Sample } from "../samples/sample";

export const SAMPLES: Sample[] = [
  {
    $key: "anise",
    cas: "0123-11-5",
    category: "Beginner",
    compound: "p-anisaldehyde",
    description: `Naturally found in fennel and anise, most commonly used
    as a synthetic flavor/fragrance`,
    free: true,
    nmr: {
      ranges: [
        {
          $key: "4b5032aa-2738-429e-baca-9ac458495899",
          type: "nmr",
          range: [[9.85, 9.88]],
          labels: [9.867],
          integration: [0.94],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "44f844ef-db45-4f07-a8c7-d475e28eedd3",
          type: "nmr",
          range: [[7.78, 7.86]],
          labels: [7.858, 7.84, 7.835],
          integration: [2.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "ff843e5d-10a6-489e-97f9-ba1ebef74201",
          type: "nmr",
          range: [[6.95, 7.02]],
          labels: [7.024, 7.006, 7.002],
          integration: [2.21],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "a6ff71b5-eae4-4618-926d-6c2c3fae96ed",
          type: "nmr",
          range: [[3.82, 3.92]],
          labels: [3.897],
          integration: [3.39],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
    ir: {
      fingerprint: [800, 1486],
      graph: {
        axis: {
          x: {
            extent: [1000, 3200],
          },
        },
      },
      ranges: [
        {
          $key: "9782f09f-bbc0-4251-80f9-c804844a593c",
          type: "ir",
          range: [[2993, 3029]],
          labels: [3006.96],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "4708710f-cf7e-4905-a017-f0a75e5c1800",
          type: "ir",
          range: [[2923, 2948]],
          labels: [2934.66],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "cea265b5-5352-44dd-b466-946ed3f717c0",
          type: "ir",
          range: [[2691, 2874]],
          labels: [2838.16, 2737.35],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "1df8f9d1-5ff4-49c0-b815-380f925ee441",
          type: "ir",
          range: [[1650, 1735]],
          labels: [1681.4],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "f2e508a2-70e8-49d7-af89-b3a2695dd5fb",
          type: "ir",
          range: [
            [1502.5, 1518.18],
            [1568.95, 1622],
          ],
          labels: [1576.39, 1509.61],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    mass: 135,
    name: "Anise",
  },
  {
    $key: "apple",
    availableAfter: ["anise"],
    cas: "0098-86-2",
    category: "Beginner",
    compound: "acetophenone",
    description: `It is naturally found in apples, apricot, bananas, and
                    cheese.`,
    free: true,
    lockedFeatures: ["buildMass", "answerMass"],
    name: "Apple",
    progress: 0,
    ir: {
      ranges: [
        {
          $key: "a5738698-2e04-404d-9f0b-844ccfc6ac6c",
          type: "ir",
          range: [[3023.34, 3116.58]],
          labels: [3062.3],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "83399e09-1206-4d4a-9a47-978132acfacd",
          type: "ir",
          range: [[2948.19, 3012.95]],
          labels: [3004.38],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "87259e85-784c-4d3a-a384-d6fb6c160154",
          type: "ir",
          range: [[1663, 1704]],
          labels: [1685.45],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "3265760d-0d30-477a-a6b7-619ec401eb69",
          type: "ir",
          range: [[1388.6, 1603.63]],
          labels: [1598.76, 1449.01],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "9a4f664a-c7da-4703-8593-127228d4e5b3",
          type: "nmr",
          range: [[7.92, 7.98]],
          labels: [7.94, 7.96],
          integration: [1.93],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "cd6f0214-368b-4f04-a7e4-eecadd059724",
          type: "nmr",
          range: [[7.52, 7.58]],
          labels: [7.49, 7.5, 7.52],
          integration: [0.97],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "c5c9508a-aacb-48ba-af09-cf9c329e9c9e",
          type: "nmr",
          range: [[7.41, 7.48]],
          labels: [7.39, 7.41, 7.43],
          integration: [1.95],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "e4208c1c-e356-4d09-abdb-a5dc9bdf4d21",
          type: "nmr",
          range: [[2.57, 2.61]],
          labels: [2.62],
          integration: [3.01],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
  },
  {
    $key: "banana",
    availableAfter: ["anise"],
    cas: "0123-51-3",
    category: "Beginner",
    compound: "isoamyl alcohol",
    description: `Found in banana oil and responsible for the aroma of
    black truffle - also responsible for the malty aroma of rum`,
    free: true,
    lockedFeatures: ["answerMass"],
    name: "Banana",
    ir: {
      ranges: [
        {
          $key: "909c49fd-6457-4c44-a705-9bf9703958b1",
          type: "ir",
          range: [[3074, 3634]],
          labels: [3334.76],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "a4bcb866-5afb-4733-9bd5-3674c5215e0a",
          type: "ir",
          range: [[3007, 2807]],
          labels: [2957.01, 2871.58],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "edec0c2a-fcf7-43b5-8dea-e34ad332a402",
          type: "nmr",
          range: [[3.64, 3.71]],
          labels: [3.688, 3.671, 3.654],
          integration: [1.98],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "73526b5e-328b-41f1-a5ad-1944d6a5054e",
          type: "nmr",
          range: [[1.645, 1.785]],
          labels: [
            1.782, 1.765, 1.749, 1.732, 1.715, 1.698, 1.681, 1.665, 1.648,
          ],
          integration: [1.0],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "d46f44d2-b3c0-490b-8c92-0e81e2646fa3",
          type: "nmr",
          range: [[1.43, 1.51]],
          labels: [1.491, 1.474, 1.457, 1.44],
          integration: [2.01],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "145b597e-4e0c-4b5a-8ced-b6654084cbe5",
          type: "nmr",
          range: [[1.3, 1.33]],
          labels: [1.317],
          integration: [0.91],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "b7eeb195-5eb1-4b36-b023-2b12e31373c1",
          type: "nmr",
          range: [[0.89, 0.94]],
          labels: [0.924, 0.907],
          integration: [6.02],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
      ],
    },
  },
  /*{
    "$key": "beer",
    "availableAfter" : [ "anise", "pastry", "beer" ],
    "cas" : "0051-45-6",
    "category" : "Intermediate",
    "compound" : "histamine",
    "description" : `the body releases/produces histamine in response to
    allergic reactions.  Histamines are also present in certain wines and
    beers`,
    "name" : "Beer",
    "ir": {
      "ranges": [
        {
          "$key": "1ec64d64-91b5-4311-ab08-d88a6e57db5d",
          "type": "ir",
          "range": [[3280, 3120]],
          "labels": [3299.99, 3248.99, 3164.91],
          "shape": "",
          "intensity": "",
          "assigned": null
        },
        {
          "$key": "0fa3f193-a657-4989-8585-98f7ae3237bf",
          "type": "ir",
          "range": [[3115, 3020]],
          "labels": [3105.17, 3057.70],
          "shape": "",
          "intensity": "",
          "assigned": null
        },
        {
          "$key": "600e3cba-bc27-4650-98da-278166f38d75",
          "type": "ir",
          "range": [[1680, 1610]],
          "labels": [1658.52],
          "shape": "",
          "intensity": "",
          "assigned": null
        }
      ]
    },
    "nmr": {
      "ranges": [
        {
          "$key": "ee96815c-db3e-4fa0-a90c-8cb1a47bf6de",
          "type": "nmr",
          "range": [[7.500,7.580]],
          "labels": [7.570],
          "integration": [0.96],
          "splitting": "",
          "assigned": null,
          "neighbours": 0
        },
        {
          "$key": "0e851a79-ddaf-4cfc-98dd-0b289b44c867",
          "type": "nmr",
          "range": [[6.780, 6.850]],
          "labels": [6.827],
          "integration": [ 0.97 ],
          "splitting": "",
          "assigned": null,
          "neighbours": 0
        },
        {
          "$key": "58a100cd-b32d-4337-80aa-601c0c207d95",
          "type": "nmr",
          "range": [[4.860, 4.935]],
          "labels": [4.897],
          "integration": [ 1.79 ],
          "splitting": "",
          "assigned": null,
          "neighbours": 0
        },
        {
          "$key": "7f9adff5-8172-465d-a9fd-f4ca30731e8f",
          "type": "nmr",
          "range": [[2.820, 2.910]],
          "labels": [ 2.879, 2.861, 2.844],
          "integration": [ 1.96 ],
          "splitting":"",
          "assigned": null,
          "neighbours": 0
        },
        {
          "$key": "a52d1a76-748a-4da8-9723-182cad8e8aba",
          "type": "nmr",
          "range": [[2.680, 2.760]],
          "labels": [ 2.723, 2.705, 2.688 ],
          "integration": [ 2.00 ],
          "splitting": "",
          "assigned": null,
          "neighbours": 0
        }
      ]
    }
  },*/
  /*{
    "$key": "cheese",
    "availableAfter" : [ "anise", "banana", "elderberry"],
    "cas" : "0051-67-2",
    "category" : "Beginner",
    "compound" : "tyramine",
    "description" : `found in chocolate, alcoholic beverages and fermented
    foods such as cheese and yogurt`,
    "name" : "Cheese",
    "ir": {
      "ranges": [
        {
          "$key": "af60ac95-17ca-4f55-9571-0c0dce49e77b",
          "type": "ir",
          "range": [[3350, 3250]],
          "labels": [3333.50, 3281.88],
          "shape": "",
          "intensity": "",
          "assigned": null
        },
        {
          "$key": "2df88e9c-4c9b-4824-9fa1-ea92516042fb",
          "type": "ir",
          "range": [[1610, 1490]],
          "labels": [1593.32, 1515.00],
          "shape": "",
          "intensity": "",
          "assigned": null
        }
      ]
    },
    "nmr": {
      "ranges": [
        {
          "$key": "e589763c-0179-4a95-9aaf-98816f761ccb",
          "type": "nmr",
          "range": [[6.900,7.180]],
          "labels": [7.018, 6.997],
          "integration": [2.00],
          "splitting": "",
          "assigned": null,
          "neighbours": 0
        },
        {
          "$key": "3129ceaa-1791-4824-b5d7-a9498522832c",
          "type": "nmr",
          "range": [[6.650, 6.780]],
          "labels": [6.713, 6.692],
          "integration": [ 1.97 ],
          "splitting": "",
          "assigned": null,
          "neighbours": 0
        },
        {
          "$key": "16371363-372f-4aab-b7f7-ef632b085ddf",
          "type": "nmr",
          "range": [[2.750, 2.850]],
          "labels": [2.822, 2.804, 2.786],
          "integration": [ 1.99 ],
          "splitting": "",
          "assigned": null,
          "neighbours": 0
        },
        {
          "$key": "19bf3bd0-6009-4fed-b4b2-c576d31c3b03",
          "type": "nmr",
          "range": [[2.580, 2.700]],
          "labels": [ 2.656, 2.638, 2.620],
          "integration": [ 2.07 ],
          "splitting":"",
          "assigned": null,
          "neighbours": 0
        }
      ]
    }
  },*/
  {
    $key: "cherry",
    availableAfter: ["anise"],
    cas: "0100-52-7",
    category: "Beginner",
    compound: "benzaldehyde",
    description: `It is naturally found in almonds and is commonly used as a
                    cherry/almond flavoring compound.`,
    free: true,
    name: "Cherry",
    progress: 0,
    ir: {
      ranges: [
        {
          $key: "ede7dbdb-5a01-4941-acb1-709c0f064c6f",
          type: "ir",
          range: [[3050, 3070]],
          labels: [3061.14],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "1220cc95-4818-4d36-8eaa-022992db3216",
          type: "ir",
          range: [[2660, 2900]],
          labels: [2735.02, 2817.03],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "2e42c0a0-0fa7-420f-acfa-d02a3457d9c8",
          type: "ir",
          range: [[1665, 1732]],
          labels: [1700.72],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "20fbcc2d-d611-4f20-9717-7651deef6781",
          type: "ir",
          range: [[1570, 1660]],
          labels: [1652.28, 1595.56, 1582.55],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "8a8212b6-f992-404d-82a0-48f324caa14c",
          type: "nmr",
          range: [[9.95, 10.02]],
          labels: [10.01],
          integration: [1.0],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "10ac89c5-3956-4c36-b981-3ac93c7a5164",
          type: "nmr",
          range: [[7.83, 7.9]],
          labels: [7.89, 7.85, 7.82],
          integration: [2.36],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "6fecaa4e-052d-47f9-bde0-fe10f19e38f9",
          type: "nmr",
          range: [[7.65, 7.59]],
          labels: [7.6, 7.62, 7.64],
          integration: [1.16],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "018b6748-a39d-4b3f-a346-8a75e176d302",
          type: "nmr",
          range: [[7.5529, 7.478]],
          labels: [7.49, 7.51, 7.53],
          integration: [2.37],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
      ],
    },
  },
  {
    $key: "chocolate-bar",
    availableAfter: ["anise"],
    //, "banana", "elderberry"
    cas: "0064-04-0",
    category: "Beginner",
    compound: "phenethylamine",
    description: "",
    free: true,
    name: "Chocolate Bar",
    ir: {
      ranges: [
        {
          $key: "97d9cc90-9398-486d-9b68-1ac3d6f8664b",
          type: "ir",
          range: [[3225, 3410]],
          labels: [3371.27, 3285.41],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "110903cb-1ab4-4408-8e12-d270a9d198de",
          type: "ir",
          range: [[3010, 3040]],
          labels: [3025.88],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "2b278e04-667c-4f84-acda-513f476df8bd",
          type: "ir",
          range: [[2885, 2960]],
          labels: [2932.05],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "cae6b928-88c8-46fe-8e90-7a515bc6e400",
          type: "ir",
          range: [[1490, 1610]],
          labels: [1603.1, 1495.95],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "2b85c991-c1d1-4d88-b529-d38f64777b2d",
          type: "nmr",
          range: [[7.172, 7.35]],
          labels: [7.323, 7.308, 7.302, 7.299, 7.285, 7.23, 7.209, 7.193],
          integration: [4.83],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "0590cfde-e3b5-4cbe-b330-a3f8f408974b",
          type: "nmr",
          range: [[2.94, 3.01]],
          labels: [2.99, 2.973, 2.972, 2.956],
          integration: [2.0],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "e8e0908a-4bc4-40eb-a042-1564137041fd",
          type: "nmr",
          range: [[2.78, 2.718]],
          labels: [2.767, 2.75, 2.733],
          integration: [2.02],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "973ff21b-ccbe-47db-bb44-2e08b9830b62",
          type: "nmr",
          range: [[0.9, 1.15]],
          labels: [1.042],
          integration: [1.82],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
      ],
    },
  },
  /*{
    "$key": "cinnamon-stick",
    "availableAfter" : [ "anise", "yogurt" ],
    "cas" : "0104-55-2",
    "category" : "Intermediate",
    "compound" : "cinnamaldehyde",
    "description" : "The essential oil of cinnamon bark is 98% this compound",
    "name" : "Cinnamon Stick",
    "nmr" : {
      "ranges": [
        {
          "$key": "d5d9bca1-f302-411d-adb1-c0286997ea71",
          "type": "nmr",
          "range": [[9.69, 9.750]],
          "labels": [9.723,9.704],
          "integration": [1.00],
          "assigned": null,
          "splitting": "",
          "neighbours": 0
        },
        {
          "$key": "e41bb380-1e72-4465-beee-1e75ec3334f0",
          "type": "nmr",
          "range": [[7.550, 7.61]],
          "labels": [ 7.585, 7.580, 7.571, 7.569, 7.560],
          "integration": [ 2.27 ],
          "assigned": null,
          "splitting": "",
          "neighbours": 0
        },
        {
          "$key": "af663fa9-8a4a-4329-ab78-ff79d20cdd62",
          "type": "nmr",
          "range": [[7.458, 7.52]],
          "labels": [7.503, 7.463],
          "integration": [ 1.00 ],
          "assigned": null,
          "splitting": "",
          "neighbours": 0
        },
        {
          "$key": "df8d0618-478b-405c-ba07-ba7cbe9b7394",
          "type": "nmr",
          "range": [[7.427, 7.452]],
          "labels": [ 7.447, 7.442, 7.434, 7.430 ],
          "integration": [ 3.00 ],
          "assigned": null,
          "splitting": "",
          "neighbours": 0
        },
        {
          "$key": "3943d222-54f6-4f65-b395-9343948809d7",
          "type": "nmr",
          "range": [[6.690, 6.760 ]],
          "labels": [ 6.756, 6.736, 6.716, 6.697],
          "integration": [ 1.11 ],
          "assigned": null,
          "splitting": "",
          "neighbours": 0
        }
      ]
    },
    "ir" : {
      "fingerprint" : [ 800, 1486 ],
      "graph" : {
        "axis" : {
          "x" : {
            "extent" : [ 1000, 3200 ]
          }
        }
      },
      "ranges" : [{
        "$key": "895c5175-7397-4316-9157-ef6e8686f94c",
        "type":"ir",
        "range": [[3050, 3080]],
        "labels": [3061.24],
        "shape": "",
        "intensity": "",
        "assigned": null
      },
      {
        "$key": "e700d7aa-0b4d-4b02-871e-1004e8fb667d",
        "type":"ir",
        "range": [[3010, 3035]],
        "labels": [3028.37],
        "shape": "",
        "intensity": "",
        "assigned": null
      },
      {
        "$key": "b72c4f63-cfda-4a5a-a5ba-94684034abb3",
        "type":"ir",
        "range": [[2800, 2860], [2799, 2720]],
        "labels": [2814.33, 2742.77],
        "shape": "",
        "intensity": "",
        "assigned": null
      },
      {
        "$key": "5c1b8367-9c3b-4e92-925c-958814a94aa5",
        "type":"ir",
        "range": [[1646, 1712]],
        "labels": [ 1673.57 ],
        "shape": "",
        "intensity": "",
        "assigned": null
      },
      {
        "$key": "89a73874-a4d3-4c6f-9198-d084bfe6d4b7",
        "type":"ir",
        "range": [ [1618, 1635] ],
        "labels": [ 1626.06],
        "shape": "",
        "intensity": "",
        "assigned": null
      },
      {
        "$key": "cdca5937-2278-4d3a-bca2-7c3266f529bc",
        "type":"ir",
        "range": [ [1570, 1613],[1560, 1590] ],
        "labels": [ 1605.31, 1575.56],
        "shape": "",
        "intensity": "",
        "assigned": null
      }]
    },
  },*/
  {
    $key: "cranberry",
    availableAfter: ["anise"],
    cas: "0104-57-4",
    category: "Beginner",
    compound: "benzyl formate",
    description: "This compound is found in sour cherries and cranberries.",
    name: "Cranberry",
    ir: {
      ranges: [
        {
          $key: "b62245b7-2f3d-4be8-90ee-4b9262c898bd",
          type: "ir",
          range: [[3000, 3050]],
          labels: [3034.62],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "8fdc3c78-8e00-4add-93e5-41143585e865",
          type: "ir",
          range: [[2900, 2980]],
          labels: [2935.0],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "13a53fd8-3b49-4ffe-b340-987a07e8065c",
          type: "ir",
          range: [[1640, 1790]],
          labels: [1723.81],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "c852cacb-c9f4-4bab-9cb3-c2ddc8665ea4",
          type: "ir",
          range: [
            [1570, 1620],
            [1485, 1506],
          ],
          labels: [1608.43, 1587.21, 1498.52],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "3b114ed9-4e0f-4ded-abf4-9e3c118614d7",
          type: "ir",
          range: [[1110, 1245]],
          labels: [1162.96],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "5013a15e-ba5d-451c-b4d7-430c21d26a4b",
          type: "nmr",
          range: [[8.1, 8.2]],
          labels: [8.148],
          integration: [0.94],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "84bcf407-0d30-49e1-8aa9-1533131aa685",
          type: "nmr",
          range: [[7.3, 7.45]],
          labels: [7.379],
          integration: [5.16],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "ad5e5878-730c-452a-9e40-a7fe43bf6675",
          type: "nmr",
          range: [[5.17, 5.25]],
          labels: [5.215, 5.213],
          integration: [2.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
  },
  {
    $key: "currants",
    availableAfter: ["anise"],
    cas: "0110-15-6",
    category: "Beginner",
    compound: "succinic acid",
    description: "This is the byproduct of bacterial fermentation.",
    name: "Currants",
    ir: {
      ranges: [
        {
          $key: "cf26e11e-8c05-42a0-aef3-3a3fff991978",
          type: "ir",
          range: [[2320, 3300]],
          labels: [2629.26],
          shape: "",
          intensity: "",
          assigned: null,
          nujol: true,
        },
        {
          $key: "81842cb5-26e8-43fd-b605-b0cbde9463c6",
          type: "ir",
          range: [[1570, 1750]],
          labels: [1693.97],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "6e112eb2-ffc0-419d-991c-e8c2271a10a1",
          type: "nmr",
          range: [[2.6, 2.7]],
          labels: [2.664],
          integration: [4.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
  },
  {
    $key: "wine-cork",
    availableAfter: ["anise"],
    cas: "0087-40-1",
    category: "Beginner",
    compound: "trichloroanisole",
    description: `Responsible for cork taint in wine.
    A product of trichlorophenol being processed by bacteria`,
    name: "Wine Cork",
    ir: {
      ranges: [
        {
          $key: "b532dcea-cb38-4820-9f23-ae580c006c52",
          type: "ir",
          range: [[3040, 3070]],
          labels: [3018.7],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "3af166c6-a1db-43ea-8b50-1f53c4769360",
          type: "ir",
          range: [[2910, 2950]],
          labels: [2945.41],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "73e5c542-d561-4980-8c7b-b8469a2ade23",
          type: "ir",
          range: [[1546, 1560]],
          labels: [1572.15],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "bd0e573f-16ed-4075-b00e-5eecee13907a",
          type: "ir",
          range: [[1450, 1480]],
          labels: [1470.5],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "6444e09a-dc56-494e-985b-43da040ad073",
          type: "ir",
          range: [[1240, 1280]],
          labels: [1215.47],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "69cd2897-70d8-4578-851b-29b46e5c6b04",
          type: "ir",
          range: [[700, 800]],
          labels: [755.86],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "3506a0b6-6a77-4e54-8373-ff60dffcfdea",
          type: "nmr",
          range: [[7.285, 7.315]],
          labels: [7.303],
          integration: [2.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "a0217a2c-707d-4b22-bbd4-f8d98fd03e81",
          type: "nmr",
          range: [[3.86, 3.9]],
          labels: [3.883],
          integration: [3.21],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
  },
  {
    $key: "water",
    availableAfter: ["anise"],
    cas: "0088-06-2",
    category: "Beginner",
    compound: "trichlorophenol",
    description: `Used as a fungicide, herbicide, insecticide, defoliant.
    It is listed as an environmental pollutant of fresh lakes.`,
    name: "Water",
    ir: {
      ranges: [
        {
          $key: "cc5ec67d-fa56-42c5-a6ba-eed1aa05c082",
          type: "ir",
          range: [[3450, 3570]],
          labels: [3525.78],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "812e7f06-0ff2-409d-b67b-85cd44593eb1",
          type: "ir",
          range: [[3000, 3060]],
          labels: [3019.08],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "0b7e4a84-315f-491c-8860-f7674bd018cf",
          type: "ir",
          range: [[1560, 1590]],
          labels: [1574.73],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "cb83e39b-57ab-4f1e-91ac-a914d40c4800",
          type: "ir",
          range: [[1442, 1484]],
          labels: [1471.11],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "1cdaef02-aa4f-4ebe-9d55-cd20a1bc4764",
          type: "ir",
          range: [[725, 800]],
          labels: [752.87],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "c18adb93-8b03-4fe8-984e-4de11b4251b2",
          type: "nmr",
          range: [[7.263, 7.285]],
          labels: [7.277],
          integration: [2.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "2d10d4b6-ecc8-4afd-97f7-200e11837588",
          type: "nmr",
          range: [[5.75, 5.82]],
          labels: [5.786],
          integration: [0.93],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
  },
  {
    $key: "elderberry",
    availableAfter: ["anise"],
    cas: "0122-78-1",
    category: "Beginner",
    compound: "phenylacetaldehyde",
    description: `This contributes to the characteristic smell of
                    elderberries.`,
    name: "Elderberry",
    ir: {
      ranges: [
        {
          $key: "b0c634bb-2042-4bfc-9768-0db153c2218e",
          type: "ir",
          range: [[3000.0, 3050]],
          labels: [3030.14],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "5dd28b09-6a9e-48db-b135-f4c6c597be2e",
          type: "ir",
          range: [[2880, 2970]],
          labels: [2923.39],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "2b55059d-ea7d-4ba3-9a06-65aa80cd4a06",
          type: "ir",
          range: [[2650, 2860]],
          labels: [2824.93, 2726.71],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "d8478728-bcbe-4420-a5cb-06b9d5a1e6b6",
          type: "ir",
          range: [[1690, 1750]],
          labels: [1723.88],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "0b648186-2986-477b-a14b-9593158363fb",
          type: "ir",
          range: [[1460, 1610]],
          labels: [1601.85, 1497.38],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "44e3bd04-03b0-46e7-997c-0db5c72bd98d",
          type: "nmr",
          range: [[9.7, 9.8]],
          labels: [9.763, 9.757, 9.752],
          integration: [0.85],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "f5936421-312f-4e91-b4c6-3843fcfb1342",
          type: "nmr",
          range: [[7.19, 7.405]],
          labels: [
            7.381, 7.377, 7.362, 7.36, 7.33, 7.312, 7.239, 7.238, 7.237, 7.236,
            7.22, 7.219, 7.218, 7.217, 7.216,
          ],
          integration: [5.25],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "86f67f66-05af-490b-aafd-15f66595a192",
          type: "nmr",
          range: [[3.684, 3.715]],
          labels: [3.696, 3.69],
          integration: [2.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
  },
  /*{
    "$key": "lemon",
    "availableAfter" : [ "anise", "lemon" ],
    "cas" : "0050-81-7",
    "category" : "Intermediate",
    "compound" : "ascorbic acid",
    "description" : "Vitamin C, found in abundance in citrus, sauerkraut.",
    "name" : "Lemon"
  },*/
  {
    $key: "pastry",
    availableAfter: ["anise", "yogurt-cup"],
    cas: "0051-79-6",
    category: "Intermediate",
    compound: "ethyl carbamate",
    description: `byproduct of yeast fermentation, known carcinogen,
    controlled to be <125 ppb.  Also used as a cosolvent for pesticides`,
    name: "Pastry",
    ir: {
      ranges: [
        {
          $key: "974f95c4-9c2b-4a59-b200-66c6398ae495",
          type: "ir",
          range: [
            [3470, 3580],
            [3380, 3340],
          ],
          labels: [3502.55, 3352.53],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "4008a684-b43f-478b-b535-43956f4ef308",
          type: "ir",
          range: [[2890, 3000]],
          labels: [2984.92],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "2beff3d2-eee6-476f-848f-74e28ec26e72",
          type: "ir",
          range: [[1630, 1730]],
          labels: [1721.27],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "ef038376-6af2-424e-a599-012f8fc0ced5",
          type: "ir",
          range: [[1230, 1290]],
          labels: [1266.23],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "ed9985c0-275a-444a-aa2c-6f014cd5c8fe",
          type: "nmr",
          range: [[4.9, 5.2]],
          labels: [4.89, 5.3],
          integration: [1.57],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "30214d50-6e36-4781-858f-dfba46f741a8",
          type: "nmr",
          range: [[4.08, 3.999]],
          labels: [4.054, 4.036, 4.018, 4.001],
          integration: [2.0],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "4847a788-6c01-4049-a7ab-f350527204a6",
          type: "nmr",
          range: [[1.1, 1.199]],
          labels: [1.188, 1.17, 1.153],
          integration: [3.04],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
      ],
    },
  },
  {
    $key: "pineapple",
    availableAfter: ["anise"],
    cas: "0050-81-7",
    category: "Beginner",
    compound: "2-pentanone",
    description: "Occurs naturally in apples and pineapples.",
    name: "Pineapple",
    ir: {
      ranges: [
        {
          $key: "8159709c-b311-4b2e-831f-7d5f26f5905a",
          type: "ir",
          range: [[2907, 3010]],
          labels: [2963.81],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "ca2ee8c1-f73f-41d4-810c-7ec03bbb17bb",
          type: "ir",
          range: [[1680, 1750]],
          labels: [1716.01],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "005530ea-22cd-457a-9344-71d14d8d6ca5",
          type: "nmr",
          range: [[2.367, 2.434]],
          labels: [2.413, 2.395, 2.376],
          integration: [2.01],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "8080475f-40e9-46f9-9a68-36f9e4a037a0",
          type: "nmr",
          range: [[2.09, 2.14]],
          labels: [2.121],
          integration: [2.92],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "a245b971-fd42-4d61-8c5c-21cbc74fd993",
          type: "nmr",
          range: [[1.54, 1.65]],
          labels: [1.641, 1.642, 1.605, 1.587, 1.569, 1.55],
          integration: [2.04],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "e640b66c-5a67-4d01-8759-6293bc6b6198",
          type: "nmr",
          range: [[0.87, 0.94]],
          labels: [0.928, 0.91, 0.891],
          integration: [3.0],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
      ],
    },
  },
  {
    $key: "raspberry",
    availableAfter: ["anise"],
    cas: "110-19-0",
    category: "Beginner",
    compound: "isobutyl acetate",
    description: `occurs naturally in pears and raspberries`,
    name: "Raspberry",
    ir: {
      ranges: [
        {
          $key: "248b7494-b447-425b-865b-ac8915523e21",
          type: "ir",
          range: [[2910, 2985]],
          labels: [2963.51],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "9d23d6ba-7d27-4ba5-9f7b-73b8c7cf0ea6",
          type: "ir",
          range: [[1695, 1790]],
          labels: [1745.67],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "09415776-eea1-4ccd-b1b1-d55c403060d4",
          type: "ir",
          range: [[1210, 1290]],
          labels: [1237.93],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "1da41bda-0371-4981-b10c-abaa15cdc67d",
          type: "nmr",
          range: [[3.82, 3.87]],
          labels: [3.846, 3.83],
          integration: [2.0],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "94d20daa-8a3e-464e-b8a2-25a13688d7bd",
          type: "nmr",
          range: [[2.03, 2.075]],
          labels: [2.045],
          integration: [3.0],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "efbe10a1-c99d-4384-a7e0-328428073f14",
          type: "nmr",
          range: [[1.867, 1.97]],
          labels: [1.964, 1.947, 1.93, 1.914, 1.897, 1.88, 1.863],
          integration: [0.91],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "0d175904-4a89-4a4e-89a8-b265d2086365",
          type: "nmr",
          range: [[0.905, 0.945]],
          labels: [0.929, 0.912],
          integration: [6.31],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
      ],
    },
  },
  {
    $key: "strawberry",
    availableAfter: ["anise"],
    cas: "0123-72-8",
    category: "Beginner",
    compound: "butyraldehyde",
    description: `This occurs naturally in apples, bananas, and
      strawberries.`,
    lockedFeatures: ["buildMass", "tableFilter"],
    mass: 72.11,
    name: "Strawberry",
    ir: {
      ranges: [
        {
          $key: "75ed7bd0-d045-4d8d-b088-029e88ac02dc",
          type: "ir",
          range: [[2851.79, 3031.25]],
          labels: [2875.57, 2962.67],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "9fa60024-5b23-47f8-b69a-4b3fa3bb6e50",
          type: "ir",
          range: [[2623.22, 2841.08]],
          labels: [2719.62, 2821.04],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "627a2da5-27f0-410e-8acd-e019fb7619b8",
          type: "ir",
          range: [[1654, 1780]],
          labels: [1725.39],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "0591c5c1-1e57-408f-ae3e-3b45eb6930f0",
          type: "nmr",
          range: [[9.71, 9.77]],
          labels: [9.73],
          integration: [0.77],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "dd604113-0e9a-4ab8-b72c-d47e7e0dbb00",
          type: "nmr",
          range: [[2.34, 2.43]],
          labels: [2.36, 2.37, 2.4],
          integration: [1.78],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "97e69902-0dbf-47ca-bc53-5fce3142400f",
          type: "nmr",
          range: [[1.58, 1.71]],
          labels: [1.61, 1.63, 1.65, 1.67],
          integration: [1.85],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
        {
          $key: "d82429bb-a12a-432d-8315-dd06ee5ca23d",
          type: "nmr",
          range: [[0.9, 0.98]],
          labels: [0.91, 0.92, 0.94],
          integration: [3.0],
          splitting: "",
          assigned: null,
          neighbours: 0,
        },
      ],
    },
  },
  {
    $key: "yogurt-cup",
    availableAfter: ["anise"],
    cas: "0050-21-5",
    category: "Beginner",
    compound: "lactic acid",
    description: "byproduct of bacterial fermentation",
    name: "Yogurt",
    ir: {
      ranges: [
        {
          $key: "e6de3594-26f1-466d-985c-df73538b8cba",
          type: "ir",
          range: [[2650, 3700]],
          labels: [3388.6],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "cc4edd87-dcc5-454c-a794-0eac1310e0a2",
          type: "ir",
          range: [[2920, 3040]],
          labels: [2989.62],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "2b3a1e5b-69b0-4490-a9be-3529bf76fc9e",
          type: "ir",
          range: [[1550, 1850]],
          labels: [1731.05],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    nmr: {
      ranges: [
        {
          $key: "cf7a3ffb-128c-4b6b-ae39-f6bdd146d241",
          type: "nmr",
          range: [[4.045, 4.14]],
          labels: [4.123, 4.106, 4.088, 4.071],
          integration: [1.03],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "2c296aa1-6086-4d5d-baa8-25912e66dc29",
          type: "nmr",
          range: [[1.28, 1.35]],
          labels: [1.323, 1.307],
          integration: [3.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
  },
  {
    $key: "coffee",
    cas: "932-16-1",
    availableAfter: ["pastry"],
    category: "Intermediate",
    compound: "2-acetyl-1-methylpyrrole",
    description: `Found in coffee aroma`,
    nmr: {
      ranges: [
        {
          $key: "b8dfc72b-08ef-4abd-b3a2-c1fd16f2f93b",
          type: "nmr",
          range: [[6.91, 6.96]],
          labels: [6.937, 6.933, 6.927, 6.923],
          integration: [0.96],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "29d837fa-249f-4055-940c-4feb0633b9b7",
          type: "nmr",
          range: [[6.76, 6.8]],
          labels: [6.786, 6.781, 6.777],
          integration: [0.96],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "a682f83e-0813-42ab-8e1b-104202c3b77e",
          type: "nmr",
          range: [[6.08, 6.14]],
          labels: [6.116, 6.11, 6.106, 6.1],
          integration: [0.96],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "95e7aed3-bbcf-4a6b-acf9-84718f397d40",
          type: "nmr",
          range: [[3.89, 3.96]],
          labels: [3.91],
          integration: [2.98],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "3b13f09e-cc56-4df9-84cb-14e1fca4cce2",
          type: "nmr",
          range: [[2.46, 2.39]],
          labels: [2.4],
          integration: [3.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
    ir: {
      graph: {
        axis: {
          x: {
            extent: [850, 3250],
          },
        },
      },
      ranges: [
        {
          $key: "c04bf2e9-03b7-4f74-8cbe-e9efb3fbb926",
          type: "ir",
          range: [[3078, 3142]],
          labels: [3108.7],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "342f15c0-bffc-40b4-a6f0-e79eabe13dcf",
          type: "ir",
          range: [[2893, 3019]],
          labels: [2950.76],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "aa13d640-d6e4-437c-99db-acca152cc1d5",
          type: "ir",
          range: [[1585, 1685]],
          labels: [1651.72],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    mass: 123.15,
    name: "Coffee",
  },
  {
    $key: "cooked-chicken",
    cas: "2497-21-4",
    availableAfter: ["pastry"],
    category: "Intermediate",
    compound: "4-Hexene-3-one",
    description: `A compound reportedly found in Cooked Chicken.`,
    nmr: {
      ranges: [
        {
          $key: "a85f60c2-01bd-4165-978b-d14ab9708fa7",
          type: "nmr",
          range: [[6.763, 6.872]],
          labels: [6.864, 6.847, 6.83, 6.825, 6.813, 6.808, 6.791, 6.774],
          integration: [0.95],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "5b791be6-9c21-437f-be88-0a7ee78f709b",
          type: "nmr",
          range: [[6.06, 6.129]],
          labels: [6.123, 6.119, 6.114, 6.112, 6.083, 6.079, 6.075, 6.072],
          integration: [0.93],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "cebab8ef-4136-429c-acaf-ee4b704ef413",
          type: "nmr",
          range: [[2.483, 2.553]],
          labels: [2.548, 2.53, 2.512, 2.493],
          integration: [1.97],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "dccd9e13-e051-4412-8827-3dfb140ac67f",
          type: "nmr",
          range: [[1.84, 1.883]],
          labels: [1.875, 1.871, 1.858, 1.854],
          integration: [3.05],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "77c94901-d166-450d-b3be-2d60b44b81e5",
          type: "nmr",
          range: [[1.033, 1.089]],
          labels: [1.078, 1.06, 1.042],
          integration: [3.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
    ir: {
      graph: {
        axis: {
          x: {
            extent: [850, 3250],
          },
        },
      },
      ranges: [
        {
          $key: "715fd5c4-05b3-4f58-94ae-2a22eddf786f",
          type: "ir",
          range: [[3015, 3048]],
          labels: [3036.4],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "a893ed53-814d-4da6-8f2f-bbff66151164",
          type: "ir",
          range: [[2906, 3005]],
          labels: [2977.06],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "17370419-b0d5-4942-9b1e-9e8275e9db10",
          type: "ir",
          range: [[1656, 1719]],
          labels: [1673.3],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "f3e9f489-16b1-4404-922a-4b6bcafcef52",
          type: "ir",
          range: [[1622, 1651]],
          labels: [1633.09],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    mass: 98.14,
    name: "Cooked Chicken",
  },
  {
    $key: "cumin",
    cas: "0122-03-02",
    availableAfter: ["pastry"],
    category: "Intermediate",
    compound: "Cuminaldehyde (4-isopropylbenzaldehyde)",
    description: `This compound is naturally occurring in cumin seeds, cinnamon, clove buds and nutmeg.`,
    nmr: {
      ranges: [
        {
          $key: "da4496ef-ad12-4540-b5ed-2d06efd9f098",
          type: "nmr",
          range: [[9.957, 9.972]],
          labels: [9.965],
          integration: [0.81],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "c410bbce-fb75-4503-9b77-79a1add5e08e",
          type: "nmr",
          range: [[7.786, 7.829]],
          labels: [7.816, 7.79],
          integration: [1.9],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "43a37221-04c9-449c-a44c-d5660b3f5e44",
          type: "nmr",
          range: [[7.357, 7.403]],
          labels: [7.388, 7.368],
          integration: [1.89],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "4ac348f2-f7c8-476e-81a5-0b4c06672c28",
          type: "nmr",
          range: [[2.925, 3.039]],
          labels: [3.033, 3.016, 2.999, 2.981, 2.964, 2.947, 2.929],
          integration: [1.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "6e5d1c8e-06ca-42bf-bfcd-e8f76882e641",
          type: "nmr",
          range: [[1.258, 1.294]],
          labels: [1.284, 1.267],
          integration: [6.3],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
    ir: {
      graph: {
        axis: {
          x: {
            extent: [950, 3350],
          },
        },
      },
      ranges: [
        {
          $key: "35e3ee2f-e418-489a-841c-ee0ff17ee0ce",
          type: "ir",
          range: [[3007, 3100]],
          labels: [3055.18],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "14c1b284-4e00-4844-8ca4-b81592b3ea67",
          type: "ir",
          range: [[2908, 2991]],
          labels: [2962.94],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "145c8b41-dc78-4f74-9dfb-70a021b5dbac",
          type: "ir",
          range: [[2695, 2888]],
          labels: [2871.23, 2732.22],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "b8f63caf-e254-497d-a770-69028ffa8148",
          type: "ir",
          range: [[1683, 1713]],
          labels: [1702.16],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "20b9a816-3155-4584-91df-18b48e7e394f",
          type: "ir",
          range: [[1563, 1616]],
          labels: [1607.2, 1575.54],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    mass: 148.2,
    name: "Cumin",
  },
  {
    $key: "grapes",
    cas: "97-85-8",
    availableAfter: ["pastry"],
    category: "Intermediate",
    compound: "Isobutyl isobutyrate",
    description: `This compound is naturally occurring in grape, apricot, banana and melon.`,
    nmr: {
      ranges: [
        {
          $key: "b06fa7cf-7aa4-4ebc-a7da-075f84788592",
          type: "nmr",
          range: [[3.822, 3.853]],
          labels: [],
          integration: [2.02],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "06471b4b-c236-49b2-ad59-aec4845d9f18",
          type: "nmr",
          range: [[2.479, 2.603]],
          labels: [2.59, 2.572, 2.554, 2.537, 2.519, 2.502, 2.484],
          integration: [0.99],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "8fbbf351-96d9-4f70-84ea-58c1ba48356e",
          type: "nmr",
          range: [[1.859, 1.971]],
          labels: [1.966, 1.949, 1.932, 1.915, 1.898, 1.882, 1.865],
          integration: [1.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "58351e0f-6a8d-4673-8cff-1c9cae3cb77e",
          type: "nmr",
          range: [[1.138, 1.175]],
          labels: [],
          integration: [6.11],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "9c8b7fb9-564e-40b9-abc8-d7f31b61bea1",
          type: "nmr",
          range: [[0.897, 0.94]],
          labels: [],
          integration: [6.25],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
    ir: {
      graph: {
        axis: {
          x: {
            extent: [850, 3350],
          },
        },
      },
      ranges: [
        {
          $key: "43c8fd64-de50-4be8-8da7-c19967b1e5cc",
          type: "ir",
          range: [[2836, 3019]],
          labels: [2970.19],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "c10e9aba-f6d4-4d05-b885-84d761870d3f",
          type: "ir",
          range: [[1670, 1773]],
          labels: [1737.89],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "72861932-b4f1-45c4-a983-1f8e99df45b0",
          type: "ir",
          range: [[1132, 1176]],
          labels: [1155.82],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    mass: 144.21,
    name: "Grapes",
  },
  {
    $key: "mango",
    cas: "623-70-1",
    availableAfter: ["pastry"],
    category: "Intermediate",
    compound: "Ethyl crotonate (ethyl-trans-2-butenoate)",
    description: `This compound is naturally occurring in mango, guava, pineapple and wild strawberry.`,
    nmr: {
      ranges: [
        {
          $key: "066b2d2a-6d6b-4c76-aa31-9abd2ec8cb1c",
          type: "nmr",
          range: [[6.882, 6.984]],
          labels: [6.978, 6.961, 6.944, 6.939, 6.926, 6.922, 6.905, 6.888],
          integration: [0.95],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "1426e33d-440f-469d-a404-faae8315b3c2",
          type: "nmr",
          range: [[5.767, 5.837]],
          labels: [5.829, 5.825, 5.82, 5.816, 5.79, 5.786, 5.782, 5.777],
          integration: [0.95],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "16bb9769-d491-4182-af08-2702de8fd58a",
          type: "nmr",
          range: [[4.104, 4.177]],
          labels: [4.169, 4.151, 4.133, 4.116],
          integration: [1.97],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "119584d4-99e3-4eec-925b-8210e14aa722",
          type: "nmr",
          range: [[1.821, 1.856]],
          labels: [1.849, 1.845, 1.832, 1.828],
          integration: [3.02],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "b24d064a-e330-41b8-9cad-229e2fdc762e",
          type: "nmr",
          range: [[1.213, 1.275]],
          labels: [1.262, 1.244, 1.226],
          integration: [3.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
    ir: {
      graph: {
        axis: {
          x: {
            extent: [850, 3350],
          },
        },
      },
      ranges: [
        {
          $key: "2f5b77e9-0ad2-485d-9811-d36fbb4346bc",
          type: "ir",
          range: [[3035, 3079]],
          labels: [3054.03],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "892c4bb9-a370-46fc-b218-cf6a4d844ec5",
          type: "ir",
          range: [[2929, 3005]],
          labels: [2981.58],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "a1b548df-1708-4453-a15c-f23941e0f83d",
          type: "ir",
          range: [[1686, 1747]],
          labels: [1721.52],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "b51a24da-1904-48ce-9c96-b2166de576ee",
          type: "ir",
          range: [[1645, 1673]],
          labels: [1662.02],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "66cb661d-5c90-47d5-9e4e-e85b873558cc",
          type: "ir",
          range: [[1137, 1222]],
          labels: [1185.58],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    mass: 114.15,
    name: "Mango",
  },
  {
    $key: "roasted-almonds",
    cas: "623-17-6",
    availableAfter: ["pastry"],
    category: "Intermediate",
    compound: "Furfuryl acetate",
    description: `Naturally occurring in roasted almonds, beer, coffee, and cocoa`,
    nmr: {
      ranges: [
        {
          $key: "bfe39250-19d8-453e-a72c-1ae9eb539303",
          type: "nmr",
          range: [[7.384, 7.428]],
          labels: [7.414, 7.413, 7.411, 7.409],
          integration: [0.42],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "d680ae49-f611-4570-8f50-fcbb23a01493",
          type: "nmr",
          range: [[6.375, 6.41]],
          labels: [6.4, 6.398, 6.392, 6.39],
          integration: [0.63],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "ec089a89-f0c5-4d39-9503-cbaff97afe9a",
          type: "nmr",
          range: [[6.332, 6.368]],
          labels: [6.358, 6.353, 6.35, 6.345],
          integration: [0.63],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "b2293d13-f749-44bd-866f-6a35e35fd165",
          type: "nmr",
          range: [[5.028, 5.064]],
          labels: [5.049],
          integration: [2.04],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "dc5794d0-c68e-4781-8d32-668dc824939c",
          type: "nmr",
          range: [[2.042, 2.086]],
          labels: [2.072],
          integration: [3.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
    ir: {
      graph: {
        axis: {
          x: {
            extent: [850, 3450],
          },
        },
      },
      ranges: [
        {
          $key: "0a072260-4992-41e1-83cf-c6dec07d628d",
          type: "ir",
          range: [[3100, 3168]],
          labels: [3149.89, 3124.25],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "15fdbc01-5dd6-41f9-9f37-5facd78c22a3",
          type: "ir",
          range: [[2907, 3007]],
          labels: [2947.63],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "c7a71e87-03f2-47ea-a3bf-9439efe19b89",
          type: "ir",
          range: [[1691, 1768]],
          labels: [1742.4],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "5af67c2f-abc7-40b6-9ec5-2d618c3a5540",
          type: "ir",
          range: [[1188, 1266]],
          labels: [1235.26],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    mass: 140.14,
    name: "Roasted Almonds",
  },
  {
    $key: "raspberry-ketone",
    cas: "5471-51-2",
    availableAfter: ["pastry"],
    category: "Intermediate",
    compound: "Raspberry Ketone / (4 Hydroxyphenyl)-2-butanone",
    description: `Responsible for raspberry aroma`,
    nmr: {
      ranges: [
        {
          $key: "c2c13a61-5a8b-42dc-9b5d-4068931379f5",
          type: "nmr",
          range: [[7.034, 7.088]],
          labels: [7.07, 7.0425],
          integration: [2.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "01a01e10-416c-4b6c-b699-1aac379dcffa",
          type: "nmr",
          range: [[6.734, 6.794]],
          labels: [6.77, 6.75],
          integration: [2.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "f144f0aa-4d98-4c1d-b701-6a82d18470ef",
          type: "nmr",
          range: [[4.966, 5.038]],
          labels: [5.0],
          integration: [0.96],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "a2067c96-013b-461f-aee1-577eddc40573",
          type: "nmr",
          range: [[2.811, 2.875]],
          labels: [2.85, 2.839, 2.831],
          integration: [2.09],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "4eb2b378-97c5-441d-95c2-5a707fcbda53",
          type: "nmr",
          range: [[2.715, 2.777]],
          labels: [2.76, 2.74, 2.72],
          integration: [2.08],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "fbf623a0-a36f-4949-ac03-1bf372528132",
          type: "nmr",
          range: [[2.138, 2.166]],
          labels: [2.15],
          integration: [3.01],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
    ir: {
      graph: {
        axis: {
          x: {
            extent: [450, 3850],
          },
        },
      },
      ranges: [
        {
          $key: "57d2886c-b868-42c4-af5d-74a862627bee",
          type: "ir",
          range: [[3174, 3521]],
          labels: [3373.42],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "aa0d5041-2584-4fe1-92da-14462c9f0dac",
          type: "ir",
          range: [[2981, 3066]],
          labels: [3022.1],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "683362c2-8b1b-43d8-9abb-cfcdc5ed7954",
          type: "ir",
          range: [[2892, 2963]],
          labels: [2949.46],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "f4886aad-aedc-4f26-ae9c-dbf02a1dd6b5",
          type: "ir",
          range: [[1650, 1707]],
          labels: [1693.41],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "63d7d139-42b3-48fc-b826-123c51bbf666",
          type: "ir",
          range: [[1472, 1626]],
          labels: [1614.87, 1515.89],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    mass: 164.21,
    name: "Raspberries",
  },
  {
    $key: "tutorial",
    cas: "78-93-3",
    availableAfter: [],
    category: "Tutorial",
    compound: "2-Butanone (methyl ethyl ketone - MEK)",
    description: `Naturally occurring in the oil of black tea, also present in coffee`,
    free: true,
    nmr: {
      ranges: [
        {
          $key: "9640fc5e-de54-4ace-b307-03ccae9ce52a",
          type: "nmr",
          range: [[2.388, 2.46]],
          labels: [],
          integration: [2.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "e726f172-8cc7-450f-b2dc-c2e4f98ab204",
          type: "nmr",
          range: [[2.09, 2.126]],
          labels: [],
          integration: [3.04],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "6658928c-7bd3-4708-ac2a-f733bf83fcd3",
          type: "nmr",
          range: [[0.995, 1.056]],
          labels: [],
          integration: [3.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
    ir: {
      graph: {
        axis: {
          x: {
            extent: [450, 3350],
          },
        },
      },
      ranges: [
        {
          $key: "c91fac77-84f0-4e8f-8502-6ab2b4c2d88e",
          type: "ir",
          range: [[2856, 3029]],
          labels: [2979.55, 2939.65],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "c004c7dc-ae2e-4478-b524-5d1a1f2d20f5",
          type: "ir",
          range: [[1633, 1784]],
          labels: [1717.35],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    mass: 72.1,
    name: "Tutorial",
  },
  {
    $key: "whiskey",
    cas: "539-88-8",
    availableAfter: ["pastry"],
    category: "Intermediate",
    compound: "Ethyl levulinate",
    description: `Naturally occurring in cognac, malt whiskey, roasted onions, and wheat bread`,
    nmr: {
      ranges: [
        {
          $key: "83239b4f-0929-4622-9cbe-d0e4cd6d2140",
          type: "nmr",
          range: [[4.066, 4.136]],
          labels: [4.13, 4.11, 4.09, 4.07],
          integration: [1.95],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "721f23bb-594a-4248-b189-9717bbb3cbc8",
          type: "nmr",
          range: [[2.691, 2.751]],
          labels: [2.73, 2.72, 2.71],
          integration: [2.05],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "ea5fcea6-3980-4c99-ab8f-7f9cc7623c2b",
          type: "nmr",
          range: [[2.51, 2.566]],
          labels: [2.55, 2.54, 2.52],
          integration: [2.02],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "9c96a9d6-6425-42fa-9a82-19d1bb1c8bdb",
          type: "nmr",
          range: [[2.147, 2.179]],
          labels: [2.16],
          integration: [3.03],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
        {
          $key: "3de1d109-43a7-426e-a98b-e2e9872374cb",
          type: "nmr",
          range: [[1.196, 1.256]],
          labels: [1.243, 1.225, 1.21],
          integration: [3.0],
          assigned: null,
          splitting: "",
          neighbours: 0,
        },
      ],
    },
    ir: {
      graph: {
        axis: {
          x: {
            extent: [750, 3250],
          },
        },
      },
      ranges: [
        {
          $key: "ff5d5bf2-a5be-43ce-93d1-aa85937445ba",
          type: "ir",
          range: [[2835, 3045]],
          labels: [2983.72],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "0ed9d084-4934-475b-9365-607c2ce059c1",
          type: "ir",
          range: [[1600, 1824]],
          labels: [1720.85],
          shape: "",
          intensity: "",
          assigned: null,
        },
        {
          $key: "44ba959b-23a6-4113-a3ac-2ceef1764aee",
          type: "ir",
          range: [[1128, 1210]],
          labels: [1158.83],
          shape: "",
          intensity: "",
          assigned: null,
        },
      ],
    },
    mass: 144.17,
    name: "Whiskey",
  },
];

export const SAMPLE_KEYS = new Set(SAMPLES.map(({ $key }) => $key));
